import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaCalendarAlt } from 'react-icons/fa';
import '../styles/Contact.css';

const Contact = () => {
  const { t } = useTranslation();

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="contact-hero-overlay"></div>
        <div className="contact-hero-content container">
          <h1>{t('contact.title')}</h1>
          <p>{t('contact.subtitle')}</p>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="contact-info-section">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-details">
              <h2>{t('contact.conversationTitle')}</h2>
              <p className="contact-intro">
                {t('contact.conversationText')}
              </p>

              <div className="contact-info-items">
                <div className="contact-info-item">
                  <div className="contact-icon">
                    <FaPhone />
                  </div>
                  <div className="contact-text">
                    <h3>{t('contact.phone')}</h3>
                    <p>(514) 677-5977</p>
                    <p className="contact-note">{t('contact.phoneHours')}</p>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="contact-icon">
                    <FaEnvelope />
                  </div>
                  <div className="contact-text">
                    <h3>{t('contact.email')}</h3>
                    <p>info@aegisconstruction.ca</p>
                    <p className="contact-note">{t('contact.emailNote')}</p>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="contact-icon">
                    <FaMapMarkerAlt />
                  </div>
                  <div className="contact-text">
                    <h3>{t('contact.location')}</h3>
                    <p>Montreal, Quebec</p>
                    <p className="contact-note">{t('contact.locationNote')}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="booking-section">
              <div className="booking-card">
                <div className="booking-icon">
                  <FaCalendarAlt />
                </div>
                <h2>{t('contact.bookingTitle')}</h2>
                <p>
                  {t('contact.bookingText')}
                </p>
                <ul className="booking-benefits">
                  <li>{t('contact.benefit1')}</li>
                  <li>{t('contact.benefit2')}</li>
                  <li>{t('contact.benefit3')}</li>
                  <li>{t('contact.benefit4')}</li>
                </ul>
                <a 
                  href="mailto:info@aegisconstruction.ca?subject=Consultation Booking&body=Hello,%0D%0A%0D%0AI would like to book a consultation to discuss my construction project.%0D%0A%0D%0APreferred Date/Time: %0D%0AProject Type: %0D%0A%0D%0AThank you!" 
                  className="booking-button"
                >
                  {t('contact.bookingButton')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section (Placeholder) */}
        <section className="map-section">
        <iframe
            title="Aegis Construction Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d179362.6726827465!2d-73.8174894!3d45.5576996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cc91a541c64b70d%3A0x654e3138211fefef!2sMontreal%2C%20QC!5e0!3m2!1sen!2sca!4v1234567890"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
        </section>
    </div>
  );
};

export default Contact;